export default __webpack_public_path__ + "assets/images/coordinatesImage-c3379f9814d55091c5b9113070cb563e.jpg";